import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../../hooks/useAuth';

interface PlatformAdminRouteProps {
  children: React.ReactNode;
}

/**
 * Route guard that requires platform admin access (is_super_admin=true)
 * Redirects to dashboard if user doesn't have platform admin privileges
 */
export const PlatformAdminRoute: React.FC<PlatformAdminRouteProps> = ({ children }) => {
  const { user, isAuthenticated } = useAuth();

  // Not authenticated - redirect to login
  if (!isAuthenticated) {
    return <Navigate to="/auth/login" replace />;
  }

  // Not platform admin - redirect to dashboard
  if (!user?.is_super_admin) {
    return <Navigate to="/dashboard" replace />;
  }

  // Platform admin - allow access
  return <>{children}</>;
};
